import { useEffect, useState } from "react";
import useElementSize from "@lib/useElementSize";

const AccordionItemBody = ({ children, isExpanded, isPreRendered }) => {
  // Using height 100% doesn't break functionality
  // despite animations not working
  const [isContainerRendered, setIsContainerRendered] = useState(false);
  const [contentHeight, setContentHeight] = useState("100%");
  const setContainerRef = useElementSize(onContentSizeChange);

  function onContentSizeChange(size) {
    if (size && contentHeight !== size) {
      setContentHeight(`${size.height}px`);
    }
  }

  useEffect(() => {
    if (isExpanded || isPreRendered) {
      setIsContainerRendered(true);
    }
  }, [isExpanded, isPreRendered]);

  const containerHeight = isExpanded ? contentHeight : 0;

  return (
    <div
      className="overflow-hidden transition-[height] ease-in-out duration-[300ms]"
      style={{ height: containerHeight }}
    >
      {isContainerRendered && (
        <div ref={setContainerRef} className="pb-8">
          {children}
        </div>
      )}
    </div>
  );
};

export default AccordionItemBody;
